import { css } from 'styled-components';
import { theme } from '../../../theme/semanticTokens';

export interface InputFieldStatusProps {
  $disabled?: boolean;
  $readOnly?: boolean;
  $error?: boolean;
}

export const inputFieldBorderStyle = css<InputFieldStatusProps>`
  border-color: ${({ $error, $disabled, $readOnly }) => {
    if ($error) return theme.dime.colors.border.critical;
    if ($disabled || $readOnly) return theme.dime.colors.border.static;
    return theme.dime.colors.border.static;
  }};
  background-color: ${({ $disabled, $readOnly }) =>
    $disabled || $readOnly
      ? theme.dime.colors.fill.disabled
      : theme.dime.colors.fill.primary};

  &:hover {
    border-color: ${({ $error, $disabled, $readOnly }) => {
      if ($error) return theme.dime.colors.border.critical;
      if ($disabled || $readOnly) return theme.dime.colors.border.static;
      return theme.dime.colors.border.interactive;
    }};
  }

  &:focus,
  &:focus-within {
    border-color: ${({ $error, $disabled, $readOnly }) => {
      if ($error) return theme.dime.colors.border.critical;
      if ($disabled || $readOnly) return theme.dime.colors.border.static;
      return theme.dime.colors.border.interactiveSelected;
    }};
    box-shadow: none;
  }
`;
